import { createContext } from "react";

export const RootPageCrumbContext = createContext<
  ((label: string | null) => void) | null
>(null);
